import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import { HEATMAP_COORDINATES } from './graphql';

function useHeatmap(questionId, segmentId) {
  return useQuery(HEATMAP_COORDINATES, {
    variables: {
      questionId,
      segmentId,
    },
    fetchPolicy: 'cache-and-network',
  });
}

useHeatmap.propTypes = {
  questionId: PropTypes.string.isRequired,
  segmentId: PropTypes.string,
};

useHeatmap.defaultProps = {
  segmentId: null,
};

export default useHeatmap;
